// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2zy8i","right":"Footer_right__3-kYa","buttons":"Footer_buttons__11sul"};